import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const useStyles = makeStyles(() => ({
  itemContainer: {
    border: `1px solid ${colors.gray200}`,
    borderRadius: "12px",
    overflow: "hidden",
    "& > .react-resizable-handle": {
      border: 0,
      borderBottom: `4px solid ${colors.gray200}`,
      borderBottomRightRadius: "12px",
      borderRight: `4px solid ${colors.gray200}`,
      bottom: -1,
      cursor: "se-resize",
      display: "inherit",
      height: "18px",
      position: "absolute",
      right: -1,
      width: "18px",
    },
    "&.react-resizable-hide > .react-resizable-handle": {
      display: "none !important",
    },
  },
}));

export default useStyles;
